import {useCallback} from 'react';

import {AppType} from '@web-catalog/types';

import {useGetVkId} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics';
import {useBaseAnalytics} from '@web-catalog/utils/analytics/useBaseAnalytics';

export const useCategoriesAnalytics = (location: 'menu' | 'bubble') => {
  const {logCatalogCategoryClick} = useBaseAnalytics();
  const getUserId = useGetVkId();

  const logAllAppsClick = useCallback(
    (alreadyActive: boolean) => {
      logTmrEvent({
        logEvent: 'allApps.click',
        params: {
          vk_id: getUserId(),
          location,
        },
      });

      logCatalogCategoryClick(AppType.MAIN, alreadyActive);
    },
    [logCatalogCategoryClick, getUserId, location],
  );

  const logAllGamesClick = useCallback(
    (alreadyActive: boolean) => {
      logTmrEvent({
        logEvent: 'allGames.click',
        params: {
          vk_id: getUserId(),
          location,
        },
      });

      logCatalogCategoryClick(AppType.GAMES, alreadyActive);
    },
    [logCatalogCategoryClick, getUserId, location],
  );

  const logAppCategorySelect = useCallback(
    (appCategoryName: string, alreadyActive: boolean) => {
      logTmrEvent({
        logEvent: 'appCategory.select',
        params: {
          app_category_name: appCategoryName,
          vk_id: getUserId(),
          location,
        },
      });

      logCatalogCategoryClick(AppType.MAIN, alreadyActive);
    },
    [logCatalogCategoryClick, getUserId, location],
  );

  const logGameCategorySelect = useCallback(
    (gameCategoryName: string, alreadyActive: boolean) => {
      logTmrEvent({
        logEvent: 'gameCategory.select',
        params: {
          app_category_name: gameCategoryName,
          vk_id: getUserId(),
          location,
        },
      });

      logCatalogCategoryClick(AppType.GAMES, alreadyActive);
    },
    [logCatalogCategoryClick, getUserId, location],
  );

  const logAppInterestingSelect = useCallback(
    (alreadyActive: boolean) => {
      logTmrEvent({
        logEvent: 'app.interesting.click',
        params: {
          vk_id: getUserId(),
          location,
        },
      });
      logCatalogCategoryClick(AppType.GAMES, alreadyActive);
    },
    [logCatalogCategoryClick, getUserId, location],
  );

  const logGameInterestingSelect = useCallback(
    (alreadyActive: boolean) => {
      logTmrEvent({
        logEvent: 'games.interesting.click',
        params: {
          vk_id: getUserId(),
          location,
        },
      });

      logCatalogCategoryClick(AppType.GAMES, alreadyActive);
    },
    [logCatalogCategoryClick, getUserId, location],
  );

  return {
    logAllAppsClick,
    logAllGamesClick,
    logAppCategorySelect,
    logGameCategorySelect,
    logAppInterestingSelect,
    logGameInterestingSelect,
  };
};
